import Drawer from "../../../../drawer/Drawer";
import ContactDetails from "../EventDetails";

const ContactDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          Contact Details
        </span>
      }
      subtitle="View information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ContactDetails data={data} />
      </div>
    </Drawer>
  );
};

export default ContactDetailsDrawer;
